import { useEffect, useState } from 'react';
import { customAxios } from '../util/fetch';
import { getCookie } from '../util/cookie';

// 파일 조회 API 가 인증을 요구해서 img src 에 URL 을 바로 넣을 수 없다. 토큰을 붙여 받아 blob URL 로 넘긴다
const useAuthFileUrl = (fileUid?: string | null) => {
  const [url, setUrl] = useState<string>();

  useEffect(() => {
    if (!fileUid) {
      setUrl(undefined);
      return;
    }
    let objectUrl: string | undefined;
    let cancelled = false;
    customAxios
      .get(`/api/file/view/${fileUid}`, {
        headers: { Authorization: `Bearer ${getCookie('token')}` },
        responseType: 'blob',
      })
      .then((res) => {
        if (cancelled) return;
        objectUrl = window.URL.createObjectURL(res.data);
        setUrl(objectUrl);
      })
      .catch(() => setUrl(undefined));
    return () => {
      cancelled = true;
      if (objectUrl) window.URL.revokeObjectURL(objectUrl);
    };
  }, [fileUid]);

  return url;
};

export default useAuthFileUrl;
